<template>
  <b-modal id="PhotoViewer"
    ref="photo-modal"
    v-model="modalShow"
    @shown="modalshown($event)"
    @hidden="modalClose($event)"
    hide-footer>
    <div class="row">
      <div class="col-12 col-md-12">
        <b-img :src="photoSrc" fluid></b-img>
      </div>
    </div>
  </b-modal>
</template>
<script >
  export default {
    data() {
      return {
        modalShow: false,
        photoSrc: '',
      }
    },

    computed: {
      $modal() {
        return this.$refs['photo-modal']
      },

      isModalVisible() {
        return this.modalShow
      },
    },

    methods: {
      showViewer() {
        if (this.isModalVisible) return

        this.modalShow = true
        // this.player.autoplay('play')

        let _this = this

        setTimeout(function () {
          
        }, 500)
      },

      closeViewer() {
        this.$modal.hide()
      },

      modalshown() {
        this.$modal['visible'] = true
      },

      modalClose() {
        
      },

      open(src) {
        if (!src || src == '') {
          return
        }

        this.photoSrc = src

        let _this = this
        setTimeout(() => {
          _this.showViewer()
        }, 100)
      },
    },
  }
  </script>



// WEBPACK FOOTER //
// src/components/PhotoViewer.vue